import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationConfig } from '../../../../config/config';
import { AirportLookupModel } from '../../../../model/airport-lookup.model';
import { ContentAirportLookup } from '../../../../model/content/contentAirportLookup.model';
import { RecentSearch } from '../../../../model/recent-search.model';
import { SavedsearchesModel } from '../../../../model/savedsearches.model';
import { CommonService } from '../../../../services/common.service';
import { ContentHeaderFooterService } from '../../../../services/content/contentheaderfooter.service';
import { SearchService } from '../../../../services/search/search.service';
import { FullAirportListComponent } from '../../../full-airport-list/full-airport-list.component';
import { AirportLookupDirective } from '../../airport-lookup.directive';

@Component({
  selector: 'ngc-airport-lookup-modal',
  templateUrl: 'airport-lookup-modal.component.html'
})
export class AirportLookupModalComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  savedSearchesAvailableFlag = false;
  displayRecentSaveSearch = false;
  recentSearchesAvailableFlag = false;
  title: string;
  tripType: string;
  selectedValue: string;
  airportLookupDir: AirportLookupDirective;
  @ViewChild('searchField') searchField: any;
  @ViewChild('recentSearchContainer') recentSearchContainer: any;
  @ViewChild('savedSearchContainer') savedSearchContainer: any;
  @ViewChild('dialog') dialog: any;
  @ViewChild('ctrl') ctrl: any;
  @ViewChild('searchResultList') searchResultList: any;
  @ViewChild('srActiveAirport') srActiveAirport: any;
  @ViewChild('srResultStatus') srResultStatus: any;
  searchedCode = '';
  searchResults: AirportLookupModel[] = [];
  savedTrips: SavedsearchesModel;
  recentSearchSelected: RecentSearch[];
  isSearchFocused: boolean;
  isSearchFieldData = false;
  timerTabSectionSubscription: Subscription;
  contentHeaderFooterServiceSubscribe: Subscription;
  config = {
    animated: false
  };

  bsModalRefAirportList: BsModalRef;
  airportLookupContent: ContentAirportLookup;
  isSearchInvoked = false;
  isAirportListScrollable = false;
  isIosSafariList = false;
  fromDest: string;
  odPairLookUp: string;
  isDelta: boolean;
  flyoutContent: any;
  contentSreach: any;
  private viewportWidth: any;
  private initialSelectionComplete = false;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private cdref: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private searchService: SearchService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private rend: Renderer2,
    public el: ElementRef,
    private dragModal: CommonService,
    private configObj: ApplicationConfig,
    private loggingService: LoggingService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.viewportWidth = window.screen.width;
      if (navigator.userAgent.indexOf('Mac') > 0) {
        this.viewportWidth = document.body.scrollWidth;
      }
    }
  }

  ngOnInit() {
    this.title = this.airportLookupContent
      ? this.title && this.title.toLowerCase() === 'origin'
        ? this.airportLookupContent.originLabel
        : this.airportLookupContent.destinationLabel
      : '';
    if (
      isPlatformBrowser(this.platformId) &&
      this.airportLookupContent == null
    ) {
      if (this.contentService.contentHeaderFooter) {
        this.contentHeaderFooterServiceSubscribe =
          this.contentService.contentHeaderFooter
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.airportLookupContent = data.airportLookup;
                  this.contentSreach =
                    data.header.auxiliaryNavigation.get('searchfeed').details;
                  this.flyoutContent = data.header.auxiliaryNavigation.get(
                    'myFlightPanel'
                  )
                    ? data.header.auxiliaryNavigation.get('myFlightPanel')
                        .details
                    : null;
                  if (
                    this.flyoutContent.isDelta !== undefined &&
                    this.flyoutContent.isDelta !== ''
                  ) {
                    this.isDelta =
                      this.flyoutContent.isDelta.toUpperCase() === 'TRUE'
                        ? true
                        : false;
                  } else {
                    this.isDelta = true;
                  }
                }
              },
              (err) => {
                this.loggingService.log('Caught Error: ' + err);
              }
            );
      }
    }
  }

  savedSearchesAvailable(event: any) {
    // #todo
  }

  selectedAirport(airport) {
    if (this.airportLookupDir) {
      this.airportLookupDir.close();
      this.airportLookupDir.selectAirport(airport);
    }
  }

  onSearchFieldFocus() {
    this.isSearchFocused = true;
    this.isSearchFieldData = false;
  }

  onSearchFieldFocusout() {
    this.isSearchFocused = false;
    const value = this.searchField.nativeElement.value;
    if (value !== null && value !== '' && value.length !== 0) {
      const parentEle = document.querySelector(
        '#airport-serach-panel .search-results'
      );
      const focusedListItem = parentEle.querySelector('li.ui-focus-active');
      if (focusedListItem !== null && focusedListItem !== undefined) {
        parentEle.classList.remove('d-block');
      }
      this.isSearchFieldData = true;
    } else {
      this.isSearchFieldData = false;
    }
  }

  onSearchValueChange() {
    const value = (this.searchedCode = this.searchField.nativeElement.value);
    if (value.length === 1 || value.length === 0 || value.length === 2) {
      this.isSearchInvoked = false;
      this.isAirportListScrollable = false;
      this.searchResults = [];
      if (value.length === 0) {
        this.clearSearchField();
      }
      this.cdref.detectChanges();
    } else if (
      value.length > 2 &&
      value.trim() !== '' &&
      this.ctrl.control.valid
    ) {
      this.isSearchInvoked = true;
      this.searchService.resultUpdate
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data && data.length > 0) {
            this.filterSearchResult(data);
          } else {
            this.srResultStatus.nativeElement.innerText = 'No search result';
          }
          if (this.isIosSafariList === true) {
            if (this.searchResults.length > 0) {
              this.onSearchFieldFocusout();
              this.el.nativeElement.querySelector('.airport-search').blur();
            }
          }
        });
      if (this.title.toLowerCase() !== 'origin') {
        this.odPairLookUp = this.airportLookupContent.odPairRestriction;
        if (
          this.odPairLookUp === 'true' &&
          this.airportLookupDir.initialLookupFromKey !== undefined
        ) {
          this.fromDest = this.airportLookupDir.initialLookupFromKey;
        } else {
          this.fromDest = '';
        }
      } else {
        this.odPairLookUp = 'false';
        this.fromDest = '';
      }
      this.searchService.getSearchCities(
        value,
        this.fromDest,
        this.odPairLookUp
      );
    }
  }

  filterSearchResult(value) {
    this.searchResults = [];
    if (
      this.title.toLowerCase() !== 'origin' &&
      this.odPairLookUp === 'true' &&
      this.airportLookupDir.initialLookupFromKey !== undefined &&
      this.airportLookupDir.tripType !== undefined &&
      this.airportLookupDir.tripType === 'MULTICITY'
    ) {
      value.forEach((airport, index) => {
        if (
          airport.restrictNonJvPartner !== undefined &&
          airport.restrictNonJvPartner.toUpperCase() === 'FALSE'
        ) {
        } else {
          this.searchResults.push(airport);
        }
      });
    } else {
      this.searchResults = value;
    }

    if (this.searchResults.length > 0) {
      this.srResultStatus.nativeElement.innerText =
        value.length +
        ' results are available, use up and down arrow keys to navigate';
    } else {
      this.srResultStatus.nativeElement.innerText = 'No search result';
    }
    this.cdref.detectChanges();
  }

  shouldShowResults(): boolean {
    return !!(
      this.searchField?.nativeElement?.value?.length > 2 &&
      this.searchResults?.length > 0 &&
      this.ctrl?.control?.valid
    );
  }

  clearSearchField() {
    this.searchField.nativeElement.value = '';
    this.searchField.nativeElement.focus();
    this.searchResults = [];
    this.isSearchInvoked = false;
    this.isAirportListScrollable = false;
    this.cdref.detectChanges();
    if (this.airportLookupDir) {
      this.airportLookupDir.initialLookupKey = null;
      this.airportLookupDir.selectedAirportValue = null;
    }
  }

  close() {
    if (this.searchResults.length === 0) {
      this.searchedCode = this.searchField.nativeElement.value;
    }
    if (this.airportLookupDir) {
      if (
        this.searchedCode !== '' &&
        this.searchedCode.length === 3 &&
        (!this.selectedValue ||
          this.selectedValue.toUpperCase() !== this.searchedCode.toUpperCase())
      ) {
        // this.airportLookupDir.getSearchedCode(this.searchedCode.toUpperCase());
        this.selectedAirport(
          new AirportLookupModel(
            this.searchedCode.toUpperCase(),
            null,
            null,
            null,
            null
          )
        );
      } else {
        this.airportLookupDir.close();
      }
    }
    this.bsModalRef.hide();
  }

  openFullAirportList() {
    const bodyScroll = document.documentElement.scrollTop;
    this.airportLookupDir.close();
    this.bsModalRef.hide();
    const obj = Object.assign({}, this.config, {
      class: 'full-airport-list-modal'
    });
    this.bsModalRefAirportList = this.modalService.show(
      FullAirportListComponent,
      obj
    );
    this.bsModalRefAirportList.content.airportLookupDir = this.airportLookupDir;
    this.bsModalRefAirportList.content.airportLookupContent =
      this.airportLookupContent;
    this.bsModalRefAirportList.content.dialog.nativeElement.focus();
    const fullAirportLostDialog = this.bsModalRefAirportList.content.dialog;
    if (
      fullAirportLostDialog &&
      fullAirportLostDialog.nativeElement &&
      fullAirportLostDialog.nativeElement.offsetParent &&
      fullAirportLostDialog.nativeElement.offsetParent.offsetParent
    ) {
      const modalContainer =
        fullAirportLostDialog.nativeElement.offsetParent.offsetParent
          .offsetParent;
      if (modalContainer !== null && modalContainer !== undefined) {
        this.rend.setStyle(modalContainer, 'z-index', '1051');
      }
    }
    this.dragModal.dragModalContainers(this.el, this.rend);
    document.documentElement.scrollTop = bodyScroll;
    this.dragModal.focusModalContainers(this.el, this.rend);
    if (this.configObj.get('APP_DISABLE_LEGACY') === 'false') {
      this.rend.addClass(
        document.getElementsByTagName('modal-container')[2],
        'fresh-air'
      );
    }
  }

  tabSelected(tabValue: string) {
    const timerTab = timer(100);
    let focusElement;
    this.timerTabSectionSubscription = timerTab.subscribe(
      (t) => {
        if (tabValue === 'search') {
          this.onSearchFieldFocus();
          this.searchField.nativeElement.focus();
        } else if (tabValue === 'recent_search') {
          focusElement =
            this.recentSearchContainer.nativeElement.querySelector('a');
          if (focusElement) {
            focusElement.focus();
          }
        } else if (tabValue === 'saved_search') {
          focusElement =
            this.savedSearchContainer.nativeElement.querySelector('a');
          if (focusElement) {
            focusElement.focus();
          }
        }
      },
      (err) => {
        this.loggingService.log('Caught Error: ' + err);
      }
    );
    this.isSearchInvoked = false;
    this.isAirportListScrollable = false;
    this.cdref.detectChanges();
  }

  getSavedTrip(event) {
    this.airportLookupDir.setSavedSearch(event);
  }

  isClose(event) {
    if (event) {
      this.close();
    }
  }

  onRecentSelected(event) {
    this.airportLookupDir.setRecentSelected(event);
    this.airportLookupDir.close();
    this.bsModalRef.hide();
  }

  ngAfterViewChecked() {
    if (
      !this.initialSelectionComplete &&
      !this.isSearchInvoked &&
      this.searchField.nativeElement.value !== '' &&
      this.selectedValue &&
      this.selectedValue !== ''
    ) {
      this.initialSelectionComplete = true;
      this.searchField.nativeElement.select();
    }
    if (this.el.nativeElement.querySelector('a')) {
      if (
        this.el.nativeElement.querySelector('a').hasAttribute('draggable') ===
          false ||
        this.el.nativeElement.querySelector('a').getAttribute('draggable') !==
          'false'
      ) {
        this.el.nativeElement
          .querySelector('a')
          .setAttribute('draggable', 'false');
      }
    }
    if (this.isSearchInvoked) {
      let searchClientHeight = 0;
      let searchScrollHeight = 0;
      let isDesktop = false;
      if (this.viewportWidth >= 991) {
        searchClientHeight =
          document.getElementsByClassName('search-results')[0].clientHeight;
        searchScrollHeight =
          document.getElementsByClassName('search-results')[0].scrollHeight;
        isDesktop = true;
        this.airportLookupDir.recalculatePosition();
      } else {
        searchClientHeight = document.getElementsByClassName(
          'search-result-container'
        )[0].clientHeight;
        searchScrollHeight = document.getElementsByClassName(
          'search-result-container'
        )[0].scrollHeight;
      }
      if (searchClientHeight !== 0) {
        this.isSearchInvoked = false;
        if (searchScrollHeight > searchClientHeight) {
          this.isAirportListScrollable = true;
          if (!isDesktop) {
            const userAgent = navigator.userAgent;
            if (!/(iPad|iPhone|iPod)/gi.test(userAgent)) {
              this.isIosSafariList = true;
            } else {
              this.isIosSafariList = this.isMobileSafari();
            }
          }
          this.cdref.detectChanges();
        } else {
          this.isAirportListScrollable = false;
        }
      }
    }
  }

  isMobileSafari() {
    const userAgent = navigator.userAgent;
    return (
      /(iPad|iPhone|iPod)/gi.test(userAgent) &&
      !/CriOS/.test(userAgent) &&
      !/FxiOS/.test(userAgent) &&
      !/OPiOS/.test(userAgent) &&
      !/mercury/.test(userAgent)
    );
  }

  selectFirstResultOnEnterKey(event) {
    this.selectedAirport(this.searchResults[0]);
    this.bsModalRef.hide();
  }

  ngOnDestroy() {
    const htmlRoot = document.getElementsByTagName('html');
    if (htmlRoot && htmlRoot.length && !this.airportLookupDir.widgetOnTop) {
      htmlRoot[0].style.overflow = '';
    }
    if (this.timerTabSectionSubscription) {
      this.timerTabSectionSubscription.unsubscribe();
    }
    if (this.contentHeaderFooterServiceSubscribe) {
      // Loadtest ObsUnsub
      this.contentHeaderFooterServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdref.detach();
  }

  handleKeyDown(event: any) {
    if (event.keyCode !== 13 && event.keyCode !== 38 && event.keyCode !== 40) {
      return;
    }
    event.preventDefault();
    // search field down key
    if (event.target && event.target.classList) {
      if (event.target.classList.contains('airport-search')) {
        if (
          this.searchResults &&
          this.searchResults.length > 0 &&
          this.searchResultList
        ) {
          // Enter
          const activeItem =
            this.searchResultList.nativeElement.querySelector(
              '.ui-focus-active'
            );
          let newActiveItem;
          if (event.keyCode === 13) {
            if (activeItem) {
              const activeIndex = activeItem.getAttribute('data-index');
              if (activeIndex) {
                const airport = this.searchResults[parseInt(activeIndex)];
                if (airport) {
                  this.selectedAirport(airport);
                }
              }
            } else {
              this.selectFirstResultOnEnterKey(event);
            }
          } else if (event.keyCode === 40) {
            if (activeItem) {
              this.rend.removeClass(activeItem, 'ui-focus-active');
              newActiveItem = activeItem.nextElementSibling;
              if (newActiveItem) {
                this.rend.addClass(newActiveItem, 'ui-focus-active');
                this.searchResultList.nativeElement.parentElement.scrollTop =
                  this.searchResultList.nativeElement.parentElement.scrollTop +
                  50;
              }
            } else {
              newActiveItem =
                this.searchResultList.nativeElement.firstElementChild;
              this.rend.addClass(newActiveItem, 'ui-focus-active');
              this.searchResultList.nativeElement.parentElement.scrollTop = 0;
            }
          } else if (event.keyCode === 38) {
            if (activeItem) {
              this.rend.removeClass(activeItem, 'ui-focus-active');
              newActiveItem = activeItem.previousElementSibling;
              if (newActiveItem) {
                this.rend.addClass(newActiveItem, 'ui-focus-active');
                this.searchResultList.nativeElement.parentElement.scrollTop =
                  this.searchResultList.nativeElement.parentElement.scrollTop -
                  50;
              }
            } else {
              newActiveItem =
                this.searchResultList.nativeElement.lastElementChild;
              if (newActiveItem) {
                this.rend.addClass(newActiveItem, 'ui-focus-active');
                this.searchResultList.nativeElement.parentElement.scrollTop =
                  this.searchResultList.nativeElement.parentElement.scrollHeight;
              }
            }
          }
          if (newActiveItem) {
            const newIndex = newActiveItem.getAttribute('data-index');
            if (newIndex) {
              const airport = this.searchResults[parseInt(newIndex)];
              if (airport) {
                this.searchField.nativeElement.value = this.selectedValue =
                  airport.airportCode;
                this.srActiveAirport.nativeElement.innerText =
                  newActiveItem.innerText.toString();
              }
            }
          } else {
            this.searchField.nativeElement.value = this.selectedValue =
              this.searchedCode;
          }
        }
      }
    }
  }
}
